import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { PENDING, FULFILLED, REJECTED } from "../../constants";
import {
  getLastPunch,
  createPunch,
//   getPunchHistory,
//   getTodayPunches,
  LastPunchResponse,
//   PunchHistoryItem,
} from "./PunchApi";

export interface PunchState {
  // Loading states
  isLoadingLastPunch: boolean;
  isCreatingPunch: boolean;
//   isLoadingHistory: boolean;
//   isLoadingTodayPunches: boolean;

  // Data
  lastPunch: LastPunchResponse['data'] | null;
//   punchHistory: PunchHistoryItem[];
//   todayPunches: PunchHistoryItem[];

  // Error states
  lastPunchError: string | null;
  createPunchError: string | null;
//   historyError: string | null;
//   todayPunchesError: string | null;
}

const initialState: PunchState = {
  // Loading states
  isLoadingLastPunch: false,
  isCreatingPunch: false,
//   isLoadingHistory: false,
//   isLoadingTodayPunches: false,

  // Data
  lastPunch: null,
//   punchHistory: [],
//   todayPunches: [],

  // Error states
  lastPunchError: null,
  createPunchError: null,
//   historyError: null,
//   todayPunchesError: null,
};

export const PunchSlice = createSlice({
  name: "punch",
  initialState,
  reducers: {
    clearPunchErrors: (state) => {
      state.lastPunchError = null;
      state.createPunchError = null;
    //   state.historyError = null;
    //   state.todayPunchesError = null;
    },
    clearLastPunch: (state) => {
      state.lastPunch = null;
      state.lastPunchError = null;
    },
    // clearPunchHistory: (state) => {
    //   state.punchHistory = [];
    //   state.historyError = null;
    // },
    // clearTodayPunches: (state) => {
    //   state.todayPunches = [];
    //   state.todayPunchesError = null;
    // },
  },
  extraReducers: (builder) => {
    // Get Last Punch
    builder
      .addCase(getLastPunch.pending, (state) => {
        state.isLoadingLastPunch = true;
        state.lastPunchError = null;
      })
      .addCase(getLastPunch.fulfilled, (state, action: PayloadAction<LastPunchResponse['data'] | null>) => {
        state.isLoadingLastPunch = false;
        state.lastPunch = action.payload;
      })
      .addCase(getLastPunch.rejected, (state, action) => {
        state.isLoadingLastPunch = false;
        state.lastPunchError = action.payload as string;
      });

    // Create Punch
    builder
      .addCase(createPunch.pending, (state) => {
        state.isCreatingPunch = true;
        state.createPunchError = null;
      })
      .addCase(createPunch.fulfilled, (state) => {
        state.isCreatingPunch = false;
      })
      .addCase(createPunch.rejected, (state, action) => {
        state.isCreatingPunch = false;
        state.createPunchError = action.payload as string;
      });

    // Get Punch History
    // builder
    //   .addCase(getPunchHistory.pending, (state) => {
    //     state.isLoadingHistory = true;
    //     state.historyError = null;
    //   })
    //   .addCase(getPunchHistory.fulfilled, (state, action: PayloadAction<PunchHistoryItem[]>) => {
    //     state.isLoadingHistory = false;
    //     state.punchHistory = action.payload;
    //   })
    //   .addCase(getPunchHistory.rejected, (state, action) => {
    //     state.isLoadingHistory = false;
    //     state.historyError = action.payload as string;
    //   });

    // // Get Today's Punches
    // builder
    //   .addCase(getTodayPunches.pending, (state) => {
    //     state.isLoadingTodayPunches = true;
    //     state.todayPunchesError = null;
    //   })
    //   .addCase(getTodayPunches.fulfilled, (state, action: PayloadAction<PunchHistoryItem[]>) => {
    //     state.isLoadingTodayPunches = false;
    //     state.todayPunches = action.payload;
    //   })
    //   .addCase(getTodayPunches.rejected, (state, action) => {
    //     state.isLoadingTodayPunches = false;
    //     state.todayPunchesError = action.payload as string;
    //   });
  },
});

export const {
  clearPunchErrors,
  clearLastPunch,
//   clearPunchHistory,
//   clearTodayPunches,
} = PunchSlice.actions;

export default PunchSlice.reducer; 